// src/components/MenuWithMotionEnhanced.js
import React from 'react';
import { motion } from 'framer-motion';
import menuData from './menuData';
import './Menu.css';
import Navbar from './Navbar';


const MenuWithMotionEnhanced = () => {
  const fadeIn = {
    hidden: { opacity: 0, y: 30 },
    visible: { opacity: 1, y: 0, transition: { duration: 0.6 } }
  };

  return (
    <>
      <Navbar />

      <div className="menu-wrapper">
        <h1 className="menu-page-title">Menu</h1>

        <div className="menu-multiday">
          {Object.entries(menuData).map(([day, dayData]) => (
            <motion.div
              key={day}
              className="menu-panel"
              initial="hidden"
              whileInView="visible"
              viewport={{ once: true, amount: 0.2 }}
              variants={fadeIn}
            >
              <div className="menu-day-heading">
                <img
                  className="menu-day-arched-title"
                  src={`/images/menu/${day.toLowerCase()}-menu.svg`}
                  alt={`${day} Title`}
                />
                <p className="menu-date">{dayData.date}</p>
              </div>

              {dayData.sections.map((section, i) => (
                <motion.div key={i} className="menu-section" variants={fadeIn}>
                  <h3 className="menu-section-title">{section.title}</h3>
                  {section.items.map((item, j) => (
                    <div key={j} className="menu-item">
                      <span className="menu-item-name">{item.name}</span>
                      <span className="menu-item-desc">{item.description}</span>
                      <span className="menu-item-price">${item.price}</span>
                    </div>
                  ))}
                </motion.div>
              ))}

              <p className="menu-footer-note">
                All main dishes are served with potatoes, rice, and/or vegetables.
              </p>
            </motion.div>
          ))}
        </div>
      </div>
    </>
  );
};

export default MenuWithMotionEnhanced;
